/** Product Workflow — VistoeraTASK-00262. The real, existing Canvas
 * flow (retired the old single-function 抠图/背景/阴影 six-step copy that
 * predates the Canvas/SaaS pivot — see git history for that version). */
const STEPS = [
  { title: '创建 Canvas 项目', desc: '在你的 Workspace 下新建一个内容生产画布。' },
  { title: '生成创意与剧本', desc: '从创意 Brief 出发，自动生成候选方向与剧本。' },
  { title: '生成分镜', desc: '从剧本自动生成分镜，编排后续生成节点。' },
  { title: '生成图片 / 视频 / 音频', desc: '按分镜连接生成节点，产出图片、视频、语音等素材。' },
  { title: '人工调整', desc: '对画布上任意一步的结果进行微调，下游自动重新生成。' },
  { title: '管理与下载资产', desc: '所有素材归属于你的 Workspace，随时管理与下载。' },
]

export default function WorkflowSection() {
  return (
    <section className="mkt-section mkt-section-alt" id="workflow">
      <div className="mkt-container">
        <h2>从原图到成品，一目了然</h2>
        <p className="mkt-section-sub">让第一次访问的人在几秒钟内理解 Vistoera 在做什么。</p>
        <div className="mkt-workflow">
          {STEPS.map((step, i) => (
            <div className="mkt-workflow-step-wrap" key={step.title} style={{ display: 'flex', alignItems: 'flex-start' }}>
              <div className="mkt-workflow-step">
                <div className="mkt-workflow-num">{i + 1}</div>
                <h3>{step.title}</h3>
                <p>{step.desc}</p>
              </div>
              {i < STEPS.length - 1 && <div className="mkt-workflow-arrow">→</div>}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
